import { render, staticRenderFns } from "./GenerateLead.vue?vue&type=template&id=4b755166&scoped=true&"
import script from "./GenerateLead.vue?vue&type=script&lang=js&"
export * from "./GenerateLead.vue?vue&type=script&lang=js&"
import style0 from "./GenerateLead.vue?vue&type=style&index=0&id=4b755166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b755166",
  null
  
)

export default component.exports